module.exports = __webpack_public_path__ + "static/img/77092H_2_3_R_20200101_LC.70d916e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77092H_2_3_R_20200101_LC.png
// module id = G+IN
// module chunks = 0